import { useCallback, MouseEventHandler } from 'react';

import { MenuItem, MenuItemProps } from '@mui/material';

import { useDropDownContext } from './DropDownContext';

type DropDownMenuItemProps = MenuItemProps<'div'> & { closeOnClick?: boolean };

export const DropDownMenuItem = ({
  children,
  closeOnClick = true,
  onClick,
  ...rest
}: DropDownMenuItemProps) => {
  const dropDownMenuContext = useDropDownContext();

  const handleClick: MouseEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      if (closeOnClick) {
        dropDownMenuContext.close();
      }

      if (onClick) {
        onClick(event);
      }
    },
    [dropDownMenuContext.close, onClick]
  );

  return (
    <MenuItem component="div" onClick={handleClick} {...rest}>
      {children}
    </MenuItem>
  );
};
